import { Container } from './common/inversify-lite';
export const container = new Container();
